class Collection {
  constructor() {
    (this.selectors = {
      section: ".facest-filters-section",
      toolbar: ".m-collection-toolbar",
      cols: [".m-toolbar--column-switcher button"],
      productContainer: "[data-product-container]",
      loadMoreBtn: "[data-load-more]",
      sidebar: ".m-sidebar",
      sidebarContent: ".m-sidebar--content",
      openSidebar: ".m-sidebar--open",
      closeSidebar: ".m-sidebar--close",
      filtersWrapper: ".m-filter--wrapper",
      modalButton: "#only-clothes",
    }),
      (this.mobileSortingSelectors = {
        openSorting: ".m-sortby--open",
        closeSorting: ".m-sortby-mobile--close",
        sortingWrapper: ".m-sortby-mobile--wrapper",
        sortingList: ".m-sortby-mobile--content",
      }),
      (this.sectionId = ""),
      (this.isDesignMode = MinimogSettings.design_mode),
      (this.currentPage = 1),
      this.paginationType,
      this.totalPages,
      this.totalProducts,
      this.infiniteLoadingObserver,
      this.showColSwitchers,
      this.cachedCol,
      this.initialCol,
      this.activeCol,
      (this.STORAGE_KEY = "gridColumnViews"),
      (this.MAX_COL_BY_SCREEN_SIZE = { mobile: 3, tablet: 3, desktop: 4 }),
      this.enableFilters,
      this.enableSorting,
      this.filtersType,
      this.filtersPosition,
      this.accordions,
      (this.sideEffectEventsAdded = !1);
  }
  init = () => {
    (this.domNodes = queryDomNodes(this.selectors)),
      (this.mbSortingNodes = queryDomNodes(this.mobileSortingSelectors)),
      this.setData();
    if (
      this.domNodes.section.getAttribute("data-collection-name") ==
      "ghost-products"
    ) {
      this.MAX_COL_BY_SCREEN_SIZE = { mobile: 2, tablet: 3, desktop: 3 };
    }
    this.initGridView(),
      this.initFilters(),
      this.initMobileSorting(),
      this.initProducts(),
      this.domNodes.modalButton?.addEventListener(
        "click",
        this.initModalButton.bind(this)
      ),
      (this.cart = document.querySelector("m-cart-drawer")),
      (this.cartPage = document.querySelector("m-cart")),
      (this.sideEffectEventsAdded = !0),
      MinimogEvents.subscribe("ON_PRODUCT_LIST_UPDATED", () =>
        refreshProductReview()
      ),
      this.handleStickyToolbar(),
      document.addEventListener("matchMobile", () =>
        this.handleStickyToolbar()
      ),
      document.addEventListener("unmatchMobile", () =>
        this.handleStickyToolbar()
      ),
      document.getElementById("only-clothes")?.classList?.contains("active") &&
        (this.domNodes.modalButton.classList.remove("active"),
        this.initModalButton());
    document.querySelectorAll(".category-tabs > button").forEach((button) => {
      button.addEventListener("click", () => {
        this.getCollection(button.dataset.handle, this.sectionId);
      });
    });

    this.outfitAddToCartBtn = document.querySelectorAll(
      "[data-outfit-add-to-cart]"
    );
    if (this.outfitAddToCartBtn.length > 0) {
      this.outfitAddToCartBtn.forEach(btn => {
        btn.addEventListener(
        "click",
        this.addOutfitVariantsToCart
      );
      });
    }
    this.outfitSeeAllBtn = document.querySelector(
      "[data-outfit-see-all]"
    );
    if (this.outfitSeeAllBtn) {
      this.outfitSeeAllBtn.addEventListener(
        "click",
        () => {
          this.outfitSeeAllBtn.querySelector(".ghost-product-container").classList.toggle("m:hidden");
        }
      );
    }
  };
  initModalButton() {
    const t = document.querySelectorAll(".all-card-images"),
      e = document.querySelectorAll(".only-cloth-image");
    this.domNodes.modalButton.classList.toggle("active"),
      t.forEach((t) => {
        t.classList.toggle("m:hidden");
      }),
      e.forEach((t) => {
        t.classList.toggle("m:hidden");
      });
  }
  addOutfitVariantsToCart = async () => {
    const variantIdsString =
      this.outfitAddToCartBtn[0].getAttribute("data-variant-ds") || "";
      if (!variantIdsString) return;
      this.outfitAddToCartBtn.forEach(btn => {
        btn.disabled = true;
      });
    const variantIds = variantIdsString
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);

    if (variantIds.length === 0) return;

    let selectedVariants = [];
    try {
      const stored = sessionStorage.getItem("selectedOutfitVariant");
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          selectedVariants = parsed;
        }
      }
    } catch (e) {
      selectedVariants = [];
    }

    const lineItems = {};
    lineItems.items = variantIds.map((variantId) => {
      let quantity = 1;
      return {
        id: variantId,
        quantity: quantity,
      };
    });
    lineItems.sections = this.cart.getSectionsToRender().map((e) => e.id);
    console.log(lineItems);
    try {
      const response = await fetch("/cart/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(lineItems),
      });
      if (!response.ok) {
        throw new Error("Failed to add items to cart");
      }
      const data = await response.json();
      if (this.cart && typeof this.cart.renderContents === "function") {
        this.cart.renderContents(data);
      }
      if (
        this.cart &&
        typeof this.cart.getCart === "function" &&
        typeof this.cart.updateCartCount === "function"
      ) {
        this.cart
          .getCart()
          .then((cartData) => {
            if (cartData && typeof cartData.item_count !== "undefined") {
              this.outfitAddToCartBtn.forEach(btn => {
                if(btn.closest('slide-popup')){
                  btn.closest('slide-popup').close();
                }
              });
              this.cart.updateCartCount(cartData.item_count);
            }
          })
          .catch((err) => {
            console.error("Failed to fetch cart for updating count:", err);
          });
      }
      this.cart.open();
    sessionStorage.setItem("selectedOutfitVariant", JSON.stringify([]));
    clearExistingRenders();
    } catch (error) {
      console.error("Error adding outfit variants to cart:", error);
    }
  };
  getCollection(handle, sectionId) {
    if (!handle || !sectionId) {
      return Promise.reject("Collection handle or section id is missing");
    }

    const url = `${handle}?section_id=${sectionId}`;
    return fetch(url, {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        document.querySelector(".ghost-collection-section-wrapper").innerHTML =
          doc.querySelector(".ghost-collection-section-wrapper").innerHTML;
        this.init();
      })
      .catch((error) => {
        console.error("Error fetching collection section:", error);
        return null;
      });
  }
  setData = () => {
    const { section: t, productContainer: e } = this.domNodes;
    (this.sectionId = t.dataset.sectionId),
      (this.paginationType = t.dataset.paginationType),
      (this.totalPages = e && Number(e.dataset.totalPages)),
      (this.view = t.dataset.view),
      (this.activeCol = null),
      (this.currentPage = 1),
      (this.initialCol = Number(t.dataset.initialColumn)),
      (this.cachedCol =
        Number(window.localStorage.getItem(this.STORAGE_KEY)) ||
        this.initialCol),
      (this.showColSwitchers = "true" === t.dataset.showColSwitchers),
      (this.enableFilters = "true" === t.dataset.enableFilters),
      (this.enableSorting = "true" === t.dataset.enableSorting),
      (this.filtersType = t.dataset.filtersType),
      (this.filtersPosition = t.dataset.filtersPosition);
  };
  initGridView = () => {
    this.toggleView(this.isDesignMode ? this.initialCol : this.cachedCol),
      this.updateViewByScreen(),
      addEventDelegate({
        selector: this.selectors.cols[0],
        context: this.domNodes.toolbar,
        handler: (t, e) => this.toggleView(Number(e.dataset.column)),
      }),
      this.initLoadMore(),
      this.sideEffectEventsAdded ||
        window.addEventListener("resize", () => {
          const t = this.getDeviceByScreenSize();
          this.prevScreen != t && debounce(this.updateViewByScreen, 500);
        });
  };
  initFilters = () => {
    if (!this.enableFilters) return;
    const { sidebar: t, openSidebar: e, closeSidebar: i } = this.domNodes;
    window.requestAnimationFrame(this.initAccordions),
      e.addEventListener("click", this.openSidebarFilter),
      i.addEventListener("click", this.closeSidebarFilter),
      t.addEventListener(
        "click",
        (e) => e.target === t && this.closeSidebarFilter()
      );
  };
  initMobileSorting = () => {
    if (!this.enableSorting) return;
    const {
      openSorting: t,
      closeSorting: e,
      sortingWrapper: i,
    } = this.mbSortingNodes;
    t.addEventListener("click", this.openMobileSorting),
      e.addEventListener("click", this.closeMobileSorting),
      i.addEventListener(
        "click",
        (t) => t.target === i && this.closeMobileSorting()
      );
  };
  openMobileSorting = () => {
    const { sortingWrapper: t, sortingList: e } = this.mbSortingNodes;
    (t.style.display = "block"),
      window.requestAnimationFrame(() => {
        t.style.setProperty("--m-bg-opacity", "0.5"),
          e.style.setProperty("--m-translate-y", "0");
      });
  };
  closeMobileSorting = (t) => {
    const { sortingWrapper: e, sortingList: i } = this.mbSortingNodes;
    e.style.setProperty("--m-bg-opacity", "0"),
      i.style.setProperty("--m-translate-y", "100%"),
      setTimeout(() => e.style.setProperty("display", "none"), 300);
  };
  initAccordions = () => {
    this.accordions && this.accordions.destroy();
    const { filtersWrapper: t } = this.domNodes;
    t.classList.remove("acc-initialized"),
      (this.accordions = new MinimogLibs.Accordion(t, {
        presetContentHeight:
          window.innerWidth > 1280 && "fixed" !== this.filtersPosition,
        callback: () => t.style.setProperty("opacity", "1"),
      }));
  };
  openSidebarFilter = () => {
    const { sidebar: t, sidebarContent: e, section: i } = this.domNodes;
    (t.style.display = "block"),
      window.requestAnimationFrame(() => {
        t.style.setProperty("--m-bg-opacity", "0.5"),
          e.style.setProperty("--m-translate-x", "0"),
          this.accordions && this.accordions.setContentHeight();
      }),
      i.classList.add("sidebar-open");
  };
  closeSidebarFilter = () => {
    const { sidebar: t, sidebarContent: e, section: i } = this.domNodes;
    i.classList.remove("sidebar-open"),
      (window.innerWidth < 1280 || "fixed" === t.dataset.type) &&
        (e.style.setProperty("--m-translate-x", "-100%"),
        t.style.removeProperty("--m-bg-opacity"),
        setTimeout(() => t.style.removeProperty("display"), 300));
  };
  toggleView = (t) => {
    if (!t || "search" === this.view) return;
    const { cols: e, productContainer: i } = this.domNodes;
    if ((console.log(e[t - 1]), !i)) return;
    const s = i.querySelectorAll("responsive-image");
    s &&
      s.length > 0 &&
      s.forEach((t) => {
        t.disconnectedCallback(), t.connectedCallback();
      });
    const o = this.activeCol || this.initialCol;
    this.showColSwitchers &&
      (e[o - 1].classList.remove("active"), e[t - 1].classList.add("active")),
      i.classList.remove(`m-cols-${o}`),
      i.classList.add(`m-cols-${t}`),
      window.localStorage.setItem(this.STORAGE_KEY, t),
      (this.activeCol = t);
  };
  updateViewByScreen = () => {
    if (1 === this.activeCol) return;
    const t = this.getDeviceByScreenSize(),
      e = this.MAX_COL_BY_SCREEN_SIZE[t];
    (this.prevScreen = t), this.toggleView(e);
  };
  getDeviceByScreenSize = () =>
    window.innerWidth < 768
      ? "mobile"
      : window.innerWidth < 1024
      ? "tablet"
      : "desktop";
  initLoadMore = () => {
    if (
      "paginate" === this.paginationType ||
      this.totalPages <= 1 ||
      "search" === this.view
    )
      return;
    const { loadMoreBtn: t } = this.domNodes;
    t.addEventListener("click", this.loadMoreProducts),
      "infinite" === this.paginationType &&
        ((this.infiniteLoadingObserver = new IntersectionObserver(
          (t) => {
            t.forEach((t) => {
              1 === t.intersectionRatio && this.loadMoreProducts();
            });
          },
          { threshold: 1 }
        )),
        this.infiniteLoadingObserver.observe(t));
  };
  loadMoreProducts = () => {
    const t = this.currentPage + 1;
    if (t > this.totalPages) return;
    const { productContainer: e, loadMoreBtn: i } = this.domNodes;
    console.log(e);
    this.toggleLoading(!0),
      fetchSection(this.sectionId, { fromCache: !0, params: { page: t } })
        .then((t) => {
          console.log(t);
          const i = t;
          if (
            document
              .getElementById("only-clothes")
              ?.classList?.contains("active")
          ) {
            const t = i.querySelectorAll(".all-card-images"),
              e = i.querySelectorAll(".only-cloth-image");
            t.forEach((t) => {
              t.classList.add("m:hidden");
            }),
              e.forEach((t) => {
                t.classList.remove("m:hidden");
              });
          }
          i
            .querySelectorAll("[data-product-container] .m-product-item")
            .forEach((t) => e.appendChild(t)),
            this.initProducts();
        })
        .catch((t) => {})
        .finally(() => {
          MinimogEvents.emit("ON_PRODUCT_LIST_UPDATED"),
            this.toggleLoading(!1),
            (this.currentPage = t),
            t >= this.totalPages &&
              (i.parentNode.remove(),
              this.infiniteLoadingObserver &&
                this.infiniteLoadingObserver.unobserve(i));
        });
  };
  initProducts = () => {
    MinimogTheme.CompareProduct &&
      MinimogTheme.CompareProduct.setCompareButtonsState(),
      MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState();
  };
  toggleLoading = (t) => {
    const { loadMoreBtn: e } = this.domNodes;
    if (e) {
      const i = t ? "add" : "remove";
      e.classList[i]("m-spinner-loading");
    }
  };
  handleStickyToolbar() {
    const t = this.domNodes.toolbar,
      e = t && t.offsetTop;
    let i = 0;
    window.addEventListener("scroll", () => {
      if (MinimogTheme.config.mqlMobile) {
        const s = window.scrollY;
        if (s <= e)
          return void t.classList.remove(
            "scroll-up",
            "m-collection-toolbar--sticky"
          );
        t.classList.add("m-collection-toolbar--sticky"),
          s > t.offsetHeight + e &&
          s > i &&
          !t.classList.contains("scroll-down")
            ? (t.classList.remove("scroll-up"), t.classList.add("scroll-down"))
            : s < i &&
              t.classList.contains("scroll-down") &&
              (t.classList.remove("scroll-down"), t.classList.add("scroll-up")),
          (i = s);
      } else
        t.classList.remove(
          "scroll-up",
          "m-collection-toolbar--sticky",
          "scroll-down"
        );
    });
  }
}

if (!customElements.get("image-scroll-bar")) {
  class t extends HTMLElement {
    constructor() {
      super(),
        (this.progressBar = document.createElement("div")),
        this.progressBar.classList.add("scroll-progress-bar"),
        (this.progressBar.style.width = "50%"),
        this.parentElement.appendChild(this.progressBar),
        this.addEventListener("scroll", this.amountScrollDiv.bind(this));
    }
    amountScrollDiv() {
      const t =
        50 + (this.scrollLeft / (this.scrollWidth - this.clientWidth)) * 100;
      this.progressBar.style.width = `${t}%`;
    }
  }
  customElements.define("image-scroll-bar", t);
}

const PDPOutfitProduct = sessionStorage.getItem("PDPOutfitProduct");
function renderFirstProduct(){
  if (!PDPOutfitProduct) return;
  
  let productData;
  try {
    productData = JSON.parse(PDPOutfitProduct);
  } catch (error) {
    console.error('Error parsing PDPOutfitProduct:', error);
    return;
  }
  
  if (!productData || !productData.variants || !Array.isArray(productData.variants)) {
    console.error('Invalid product data or missing variants');
    return;
  }
  
  console.log(productData);
  
  const html = `
   <ghost-product-card class="custom-product-card" 
      style="
      text-align:left; 
      position: relative;
      text-align: left;
      position: relative;
      max-width: 280px;
      width: 90%;
      background: white;
      padding: 20px;
      "
      >
      <div style="display:block; text-decoration:none; color:inherit;">
         <div class="custom-product-card__image" style="text-align:center;position:relative;">
            <responsive-image class="m-image m-image-loaded" style="--aspect-ratio: 0.6665416354088523;" intersecting="true">
               <img src="${productData.image}" alt="${productData.title}" srcset="${productData.image} 100w" sizes="311px" loading="lazy" class="" width="311" height="466">
               <noscript>
                  <img class="" loading="lazy" width="" height="" src="${productData.image}" alt="${productData.title}">
               </noscript>
            </responsive-image>
            <!-- Outfit Button -->
            <button class="add-to-outfit-btn m:font-medium" type="button" onclick="this.closest('ghost-product-card').toggleOutfitVariant(this)">
            ADD
            </button>
            </div>
         <div class="custom-product-card__info" style="margin-top:12px;">
            <div class="m:flex m:items-center m:justify-between">
               <div class="m-product-card__name">
                  ${productData.title}
               </div>
               <span class="custom-product-card__price" style="color:#222; font-weight:500;">
                ${productData.price}
               </span>
            </div>
         </div>
      </div>
         <!-- Variant Popup Overlay -->
            <div class="outfit-variant-overlay">
               <button class="close-variant-overlay" type="button" title="Close" onclick="this.closest('ghost-product-card').closeOutfitVariant(this)">
               ×
               </button>
               <!-- Variant List -->
               <div class="outfit-variant-list">
                ${
                  productData.variants.map(variant => `
                    <button class="outfit-variant-btn ${variant.available ? '' : 'out-of-stock'}" type="button" data-variant-id="${variant.id}" data-variant-title="${productData.title}" data-variant-price="${productData.price}" data-variant-compare-price="${productData.comparePrice}" data-variant-image="${productData.image}" title="Select ${variant.title}" ${variant.available ? '' : 'disabled'}>
                      ${variant.title}
                    </button>
                  `).join('')
                }   
               </div>
               <!-- Selected Info -->
               <div class="outfit-variant-selected-info" style="display: none;"></div>
            </div>
   </ghost-product-card>
  `;
  const pdpwrapper = document.querySelector('.direct-pdp-product');
  if (pdpwrapper) {
    pdpwrapper.insertAdjacentHTML('beforeend',html);
    pdpwrapper.style.display='flex';
  }

}
if(PDPOutfitProduct){
  renderFirstProduct()
}
function render() {
  const selectedVariants = getSelectedVariantsFromStorage();
  const addToCartBtn = document.querySelectorAll("[data-outfit-add-to-cart]");
  if (addToCartBtn.length > 0) {
    addToCartBtn.forEach(btn => {
      btn.disabled = selectedVariants.length === 0;
    });
  }
  clearExistingRenders();
  if (selectedVariants.length === 0) return;
  clearExistingRenders();
  renderSelectedVariants(selectedVariants);
  addToCartBtn.forEach(btn => {
    updateAddToCartButton(selectedVariants,btn);
  });
  updateProductCount(selectedVariants);
}



function updateProductCount(selectedVariants) {
  const countElement = document.querySelector("[ghost-product-count-number]");
  if (!countElement) return;
  
  const productCount = selectedVariants.length;
  countElement.textContent = productCount;
}

function updateAddToCartButton(selectedVariants,addToCartBtn) {
  if (!addToCartBtn) return;
  
  const variantIds = selectedVariants
    .map(variant => variant.variantId)
    .filter(Boolean);
  
  const variantIdString = variantIds.join(",");
  addToCartBtn.setAttribute("data-variant-ds", variantIdString);
}

function getSelectedVariantsFromStorage() {
  try {
    const stored = sessionStorage.getItem("selectedOutfitVariant");
    if (!stored) return [];
    
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error("Error parsing selected variants from storage:", error);
    return [];
  }
}

function clearExistingRenders() {
  // Clear existing draggable elements
  document.querySelectorAll("draggable-element").forEach(element => {
    element.remove();
  });
  
  // Clear existing ghost products
  const ghostWrapper = document.getElementById("ghost-product-wrapper");
  if (ghostWrapper) {
    ghostWrapper.innerHTML = "";
  }
  // Also clear the product count to 0
  const countElement = document.querySelector("[ghost-product-count-number]");
  if (countElement) {
    countElement.textContent = "0";
  }
  // Clear the Add to Cart button's variant data attribute
  const addToCartBtn = document.querySelectorAll("[data-outfit-add-to-cart]");
  if (addToCartBtn.length > 0) {
    addToCartBtn.forEach(btn => {
      btn.setAttribute("data-variant-ds", "");
    });
  }
}

function renderSelectedVariants(variants) {
  variants.forEach(variant => {
    renderDraggableElement(variant);
    renderGhostProduct(variant);
  });
}
// console.log(window.innerWidth);
function renderDraggableElement(variant) {
  const position = getValidPosition(variant.position);
  const draggableHTML = createDraggableElementHTML(variant, position);
  if (window.innerWidth > 1023) {
    const parent = document.getElementById("parent-side");
    if (parent) {
      parent.insertAdjacentHTML("beforeend", draggableHTML);
    }
  } else {
    const parent = document.getElementById("parent-popup");
    if (parent) {
      parent.insertAdjacentHTML("beforeend", draggableHTML);
    }
  }
}

function renderGhostProduct(variant) {
  const ghostProductHTML = createGhostProductHTML(variant);
  const wrapper = document.getElementById("ghost-product-wrapper");
  
  if (wrapper) {
    wrapper.insertAdjacentHTML("beforeend", ghostProductHTML);
  }
}
function getRandomNumberBetween10And99() {
  return Math.floor(Math.random() * 180) + 10;
}


function getValidPosition(position) {
  if (position && 
      typeof position.left === "number" && 
      typeof position.top === "number") {
    return position;
  }
  return { left: getRandomNumberBetween10And99(), top: getRandomNumberBetween10And99() };
}

function createDraggableElementHTML(variant, position) {
  const imageUrl = variant.imageUrl || "";
  
  return `
    <draggable-element 
      width="100px" 
      height="100px" 
      text="Drag me" 
      data-variant-id="${variant.variantId}" 
      style="left:${position.left}px; top:${position.top}px;"
      class=""
    >
      <div class="controles">
        <button class="delete-btn" id="delete-btn">×</button>
        <div class="controls">
          <button id="zoom-out">−</button>
          <button id="zoom-in">+</button>
        </div>
      </div>
      <img src="${imageUrl}" alt="Outfit Variant" srcset="${imageUrl} 100w" style="width:100%;height:auto;">
    </draggable-element>
  `;
}

function createGhostProductHTML(variant) {
  return `
    <div class="ghost-product" style="text-align:left;box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);padding:5px;border-radius:5px;">
      <div class="ghost-product-image">
        <img src="${variant.imageUrl}" alt="${variant.title}" srcset="${variant.imageUrl} 100w" width="100" height="150">
      </div>
      <div class="ghost-product-title-wrapper">
        ${variant.title}
      </div>
      <div class="ghost-product-price-wrapper m:display-flex" style="gap:10px"> 
        ${variant.price}
        <span class="ghost-product-price-compare" style="text-decoration: line-through; color:red">
          <s>${variant.comparePrice}</s>
        </span>
      </div>
    </div>
  `;
  
}
render();

class DraggableElement extends HTMLElement {
  constructor() {
    super();
    this.initializeProperties();
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  // Initialization
  initializeProperties() {
    this.scale = 1;
    this.minScale = 0.5;
    this.maxScale = 2;
    this.scaleStep = 0.1;
    this.isDragging = false;
    this.offsetX = 0;
    this.offsetY = 0;
    this.minWidth = 40;
    this.maxWidth = 280;
    this.widthStep = 20;
  }

  setupEventListeners() {
    this.setupDragEvents();
    this.setupControlEvents();
  }

  // Drag functionality
  setupDragEvents() {
    this.setupMouseDragEvents();
    this.setupTouchDragEvents();
    this.setupDragEndEvents();
  }

  setupMouseDragEvents() {
    this.addEventListener("mousedown", (e) => {
      if (this.isControlButton(e.target)) return;
      this.startDragging(e.clientX, e.clientY);
    });

    document.addEventListener("mousemove", (e) => {
      if (!this.isDragging) return;
      this.handleDragMove(e.clientX, e.clientY);
    });
  }

  setupTouchDragEvents() {
    this.addEventListener("touchstart", (e) => {
      if (this.isControlButton(e.target)) return;
      e.preventDefault();
      const touch = e.touches[0];
      this.startDragging(touch.clientX, touch.clientY);
    });

    document.addEventListener("touchmove", (e) => {
      if (!this.isDragging) return;
      e.preventDefault();
      const touch = e.touches[0];
      this.handleDragMove(touch.clientX, touch.clientY);
    });
  }

  setupDragEndEvents() {
    const savePosition = () => {
      this.savePositionToStorage();
      this.stopDragging();
      console.log("savePosition");
    };

    document.addEventListener("mouseup", savePosition);
    document.addEventListener("touchend", savePosition);
  }

  startDragging(clientX, clientY) {
    this.isDragging = true;
    this.offsetX = clientX - this.offsetLeft;
    this.offsetY = clientY - this.offsetTop;
    this.classList.add("dragging");
  }

  handleDragMove(clientX, clientY) {
    const position = this.calculateConstrainedPosition(clientX, clientY);
    this.setPosition(position.x, position.y);
  }

  calculateConstrainedPosition(clientX, clientY) {
    const parent = this.parentElement;
    if (!parent) return { x: 0, y: 0 };

    let x = clientX - this.offsetX;
    let y = clientY - this.offsetY;

    const width = this.offsetWidth * this.scale;
    const height = this.offsetHeight * this.scale;

    x = Math.max(0, Math.min(x, parent.clientWidth - width));
    y = Math.max(0, Math.min(y, parent.clientHeight - height));

    return { x, y };
  }

  setPosition(x, y) {
    this.style.left = x + "px";
    this.style.top = y + "px";
  }

  stopDragging() {
    this.isDragging = false;
    this.classList.remove("dragging");
  }

  // Control functionality
  setupControlEvents() {
    const zoomInBtn = this.querySelector("#zoom-in");
    const zoomOutBtn = this.querySelector("#zoom-out");
    const deleteBtn = this.querySelector("#delete-btn");

    if (zoomInBtn) zoomInBtn.addEventListener("click", (e) => this.handleZoomIn(e));
    if (zoomOutBtn) zoomOutBtn.addEventListener("click", (e) => this.handleZoomOut(e));
    if (deleteBtn) deleteBtn.addEventListener("click", (e) => this.handleDelete(e));
  }

  handleZoomIn(e) {
    e.stopPropagation();
    const currentWidth = this.getCurrentWidth();
    if (currentWidth >= this.maxWidth) return;
    
    const newWidth = Math.min(currentWidth + this.widthStep, this.maxWidth);
    this.setCurrentWidth(newWidth);
  }

  handleZoomOut(e) {
    e.stopPropagation();
    const currentWidth = this.getCurrentWidth();
    if (currentWidth <= this.minWidth) return;
    
    const newWidth = Math.max(currentWidth - this.widthStep, this.minWidth);
    this.setCurrentWidth(newWidth);
  }

  handleDelete(e) {
    e.stopPropagation();
    this.removeFromStorage();
    render();
  }

  // Utility methods
  isControlButton(target) {
    const controlSelectors = ["#zoom-in", "#zoom-out", "#delete-btn"];
    return controlSelectors.some(selector => target.matches(selector));
  }

  getCurrentWidth() {
    const width = this.style.width;
    if (width && width.endsWith("px")) {
      return parseInt(width, 10);
    }
    return this.offsetWidth;
  }

  setCurrentWidth(newWidth) {
    this.style.width = newWidth + "px";
  }

  // Storage management
  savePositionToStorage() {
    try {
      const selectedVariants = this.getSelectedVariantsFromStorage();
      if (!selectedVariants.length) return;

      const variantId = this.getAttribute("data-variant-id");
      if (!variantId) return;

      const variantObj = selectedVariants.find(
        (v) => String(v.variantId) === String(variantId)
      );
      if (!variantObj) return;

      const position = this.getCurrentPosition();
      console.log("position",position);
      variantObj.position = position;

      this.saveToStorage(selectedVariants);
    } catch (error) {
      console.error("Error saving position to storage:", error);
    }
  }

  getCurrentPosition() {
    const left = this.style.left ? parseInt(this.style.left, 10) : this.offsetLeft;
    const top = this.style.top ? parseInt(this.style.top, 10) : this.offsetTop;
    return { left, top };
  }

  removeFromStorage() {
    try {
      const selectedVariants = this.getSelectedVariantsFromStorage();
      const variantIdToRemove = this.getAttribute("data-variant-id");
      
      const updatedVariants = selectedVariants.filter(
        (v) => String(v.variantId) !== String(variantIdToRemove)
      );
      
      this.saveToStorage(updatedVariants);
    } catch (error) {
      console.error("Error removing from storage:", error);
      this.saveToStorage([]);
    }
  }

  getSelectedVariantsFromStorage() {
    const stored = sessionStorage.getItem("selectedOutfitVariant");
    if (!stored) return [];
    
    try {
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing storage data:", error);
      return [];
    }
  }

  saveToStorage(data) {
    sessionStorage.setItem("selectedOutfitVariant", JSON.stringify(data));
  }

  // Animation methods
  updateScale() {
    this.style.transform = `scale(${this.scale})`;
  }

  deleteElement() {
    this.animateDeletion(() => {
      if (this.parentElement) {
        this.parentElement.removeChild(this);
      }
    });
  }

  animateDeletion(callback) {
    this.style.transition = "opacity 0.3s ease-out, transform 0.3s ease-out";
    this.style.opacity = "0";
    this.style.transform = "scale(0.8)";

    setTimeout(callback, 300);
  }
}

// Register the custom element
customElements.define("draggable-element", DraggableElement);

class GhostProductCard extends HTMLElement {
  constructor() {
    super();
    this.selectedVariant = null;
    this.init();
  }
  connectedCallback() {
    this.init();
    this.bindEvents();
  }

  init() {
    // Initialize any setup if needed
    this.allVariants = this.querySelectorAll('.outfit-variant-btn');
    this.overlay = this.querySelector('.outfit-variant-overlay');
    this.addOutfitBtn = this.querySelector('.add-to-outfit-btn');
  }

  bindEvents() {
    // Event binding can be added here if needed
    this.allVariants.forEach(variant => {
      variant.addEventListener('click', (e) => this.selectOutfitVariant(e));
    });
    this.addOutfitBtn.addEventListener('click', (e) => this.toggleOutfitVariant(e));
  }

  // Public methods
  toggleOutfitVariant(button) {
    // button.event.stopImmediatePropagation();
    this.closeOtherOverlays(button);
    this.toggleCurrentOverlay(button);
  }

  closeOutfitVariant(closeButton) {
    const overlay = closeButton.closest('.outfit-variant-overlay');
    if (overlay) {
      overlay.classList.remove('active');
    }
  }

  selectOutfitVariant(e) {
    console.log("selectOutfitVariant",e);
    const button = e.target;
    const variantId = button.getAttribute('data-variant-id');
    const title = button.getAttribute('data-variant-title');
    const price = button.getAttribute('data-variant-price');
    const comparePrice = button.getAttribute('data-variant-compare-price');
    const imageUrl = button.getAttribute('data-variant-image');
    const size = button.textContent.trim();
    if (this.isOutOfStock(button)) return;

    this.updateVariantSelection(button);
    this.showSelectionInfo(button, size);
    this.handleVariantSelection(size, variantId, imageUrl, price, comparePrice, title);
  }

  // Private methods
  closeOtherOverlays(currentButton) {
    const currentOverlay = currentButton.nextElementSibling;
    document.querySelectorAll('.outfit-variant-overlay.active').forEach((overlay) => {
      if (overlay !== currentOverlay) {
        overlay.classList.remove('active');
      }
    });
  }

  toggleCurrentOverlay(button) {
    if (this.overlay) {
      this.overlay.classList.toggle('active');
    }
  }

  isOutOfStock(button) {
    return button.classList.contains('out-of-stock');
  }

  updateVariantSelection(selectedButton) {
    if (!this.overlay) return;

    // Remove previous selection
    this.overlay.querySelectorAll('.outfit-variant-btn').forEach((btn) => {
      btn.classList.remove('selected');
    });

    // Add selection to current button
    selectedButton.classList.add('selected');
  }

  showSelectionInfo(button, size) {
    if (!this.overlay) return;

    const info = this.overlay.querySelector('.outfit-variant-selected-info');
    if (info) {
      info.textContent = 'Selected: ' + size;
      info.style.display = 'block';
    }
  }

  handleVariantSelection(size, variantId, imageUrl, price, comparePrice, title) {
    const variantData = this.createVariantData(size, variantId, imageUrl, price, comparePrice, title);
    
    this.saveToSessionStorage(variantData);
    // this.addDraggableElement(variantData);
    // this.addGhostProduct(variantData);
    // this.updateAddToCartButton(variantId);
    if(this.closest(".direct-pdp-product")){
      this.closest(".direct-pdp-product").remove();
      sessionStorage.removeItem("PDPOutfitProduct");
    }
    render();
    this.handleMobilePopup();
  }

  createVariantData(size, variantId, imageUrl, price, comparePrice, title) {
    return {
      size,
      variantId,
      imageUrl,
      price,
      comparePrice,
      title
    };
  }

  saveToSessionStorage(variantData) {
    try {
      let selectedVariants = this.getExistingVariants();
      selectedVariants.push(variantData);
      sessionStorage.setItem('selectedOutfitVariant', JSON.stringify(selectedVariants));
    } catch (error) {
      console.error('Error saving to session storage:', error);
    }
  }

  getExistingVariants() {
    const existing = sessionStorage.getItem('selectedOutfitVariant');
    if (existing) {
      try {
        const parsed = JSON.parse(existing);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.error('Error parsing existing variants:', error);
        return [];
      }
    }
    return [];
  }

  addDraggableElement(variantData) {
    const draggableHTML = this.createDraggableHTML(variantData);
    document.querySelectorAll('#parent').forEach(parent => {
      parent.insertAdjacentHTML('beforeend', draggableHTML);
    });
  }

  createDraggableHTML(variantData) {
    return `
      <draggable-element width="100px" height="100px" text="Drag me" class="">
        <div class="controles">
          <button class="delete-btn" id="delete-btn">×</button>
          <div class="controls">
            <button id="zoom-out">−</button>
            <button id="zoom-in">+</button>
          </div>
        </div>
        <img src="${variantData.imageUrl}" alt="${variantData.title}" srcset="${variantData.imageUrl} 100w" style="width:100%;height:auto;">
      </draggable-element>
    `;
  }

  addGhostProduct(variantData) {
    const ghostProductHTML = this.createGhostProductHTML(variantData);
    const wrapper = document.getElementById('ghost-product-wrapper');
    if (wrapper) {
      wrapper.insertAdjacentHTML('beforeend', ghostProductHTML);
    }
  }

  createGhostProductHTML(variantData) {
    return `
      <div class="ghost-product" style="border:1px solid #ccc;padding:5px;border-radius:5px;">
        <div class="ghost-product-image">
          <img src="${variantData.imageUrl}" alt="${variantData.title}" srcset="${variantData.imageUrl} 100w" width="100" height="150">
        </div>
        <div class="ghost-product-title-wrapper">
          ${variantData.title}
        </div>
        <div class="ghost-product-price-wrapper m:display-flex" style="gap:10px"> 
          ${variantData.price}
          <span class="ghost-product-price-compare" style="text-decoration: line-through; color:red">
            <s>${variantData.comparePrice}</s>
          </span>
        </div>
      </div>
    `;
  }

  updateAddToCartButton(variantId) {
    const addToCartBtn = document.querySelector('[data-outfit-add-to-cart]');
    if (addToCartBtn) {
      let currentAttr = addToCartBtn.getAttribute('data-variant-ds') || '';
      currentAttr = currentAttr.length > 0 ? `${currentAttr},${variantId}` : variantId.toString();
      addToCartBtn.setAttribute('data-variant-ds', currentAttr);
    }
  }

  handleMobilePopup() {
    if (window.screen.availWidth < 768) {
      const popup = document.querySelector('#gosh-popup');
      if (popup && popup.open) {
        popup.open();
      }
    }
  }
}

// Register the custom element
customElements.define('ghost-product-card', GhostProductCard);

const ghostCloseButton = document.querySelector(".direct-pdp-product .close-button");
if(ghostCloseButton){
  ghostCloseButton.addEventListener("click",function(){
   this.parentElement.remove();
  });
}